/*
 * This component polls the DOM every 2 seconds for elements (div.load-on-visible) that were formerly hidden but are now visible.
 * Once they become visible it triggers a 'becamevisible' event and optionally if a data-href="" attribute is set will load in 
 * content from that URL. This plugin only works on an elements visibility property, and doesn't do anything with if the element
 * is visible in the viewport or not.
 */
// Load on visible component
$(document).bind('becamevisible', function(evt) {
	$('.load-on-visible', evt.target)
		.removeClass('load-on-visible')
		.each(function() {
			var data = $(this).dataset();
			if ( data.href ) {
				// Test if this element is in the visible viewport
				$(this)
					.trigger('onvisibleloading')
					.load( data.href, function() {
						$(this).trigger('onvisiblecomplete');
						$('.origin-button').originButton();
					});
			} else if ( data.action ) {
				$(this)
					.doAction(data.action);
			} else {
				var event = data.event || 'visible';
				$(this)
					.trigger(event);
			}
		});
});
function onVisibleCallback() {
	$('div.load-on-visible:visible')
		.each(function() {
			// Trigger the event on the parent because the search will look 
			// for all child elements with load-on-visible
			$(this).parent().trigger('becamevisible');
		});
	setTimeout(onVisibleCallback, 2000);
}
setTimeout(onVisibleCallback, 2000);